import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerData: {
    // default value to be empty string for now
    customerType: "",
    metaData: {
      appName: "",
      clientType: "",
      resource: "",
      utm_source: "",
      utm_medium: "",
      producerRole: "",
      productType: "",
      solId: "",
      producerCode: "",
      SelectedTab: "",
      producerEmailId: "",
      userType: "",
    },
  },
  permissions: { create: true, read: true, update: false, delete: false },
  formDetail: {},
};

export const metadataSlice = createSlice({
  name: "metadata",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCustomerData: (state, action) => {
      state.customerData = action.payload.customerData;
    },
    clearCustomerData: () => {
      return initialState;
    },
  },
});

export const { setCustomerData, clearCustomerData } = metadataSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getMetadata = (state) => state.metadata?.customerData.metaData;

export const getCustomerType = (state) =>
  state.metadata?.customerData.customerType;

export default metadataSlice.reducer;
